export const FUSIONAUTH_TOKEN_KEY = "fusionauth_token";
